import React from "react";
import { Navigate } from "react-router-dom";

const PrivateRoute = ({ children }) => {
  const isAuthenticated = localStorage.getItem("token-shata"); // Check if token exists

  return isAuthenticated ? children : <Navigate to="/" />;
};

export default PrivateRoute;